export default __webpack_public_path__ + "static/wearetheart-331ea169c1969a40a8859b5a85006618.jpg";